import React from 'react';
import { Grommet } from 'grommet';
import { css } from 'styled-components';
import 'AppEntry/App.css';
import AppRoutes from './routes';
import { withFirebaseProvider } from 'components/common/Firebase';
import { AuthorizedUserProvider } from 'components/common/AuthorizedUser';
import { UserDataProvider } from 'components/common/UserData';
// import Account from 'components/common/Account' TODO
// COMPONENTS
import NotificationsComponent from 'components/common/Notifications';
// APOLLO
import client from 'ApolloClient/index.js';
import { ApolloProvider } from 'react-apollo';

const zaaasTheme = {
  global: {
    breakpoints: {
      small: { value: 768 },
      medium: { value: 920 }
    },
    colors: {
      background: '#ffffff'
    },
    font: {
      family:
        '-apple-system, Ubuntu, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Cantarell, "Fira Sans", "Droid Sans",  "Helvetica Neue", Arial, sans-serif,  "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
      color: 'brand'
    }
  },
  /*anchor: {
    extend: css`
      ${props => !props.plain && ''}
  } TODO */
  button: {
    extend: css`
      ${props => !props.plain && 'font-weight: bold;'}
    `
  }
};

let notifications;

export const addNotification = (title, body, color = '', params = {}) => {
  //EXAMPLE OF ADD NOTIFICATION FUNCTION
  // notifications.addNotification('Title', 'Some random body text', 'warning', {position: 'top-right'})
  // notifications.addNotification('Title', 'Some random body text', '#fff')
  // notifications.addNotification('Title', 'Some random body text')
  notifications.addNotification(title, body, color, params);
};

class App extends React.Component {
  render() {
    return (
      <Grommet theme={zaaasTheme}>
        <AuthorizedUserProvider>
          <UserDataProvider>
            <ApolloProvider client={client}>
              <NotificationsComponent
                innerRef={node => (notifications = node)}
              />
              <AppRoutes {...this.props} />
            </ApolloProvider>
          </UserDataProvider>
        </AuthorizedUserProvider>
      </Grommet>
    );
  }
}

export default withFirebaseProvider(App);
